import { Account, DOCUMENT, IDocument } from 'entities/user/module'

import { IProfileTypes, ProfileTypes } from 'shared/constants'

export const selectTypePassport = (
  account: Account | null,
  isPass: boolean,
  type: string | undefined,
) => {
  let currentPassport: Partial<IDocument> | undefined = isPass
    ? account?.id_card
    : account?.international_passport

  if (!currentPassport) {
    currentPassport = {
      ...account?.id_card,
      document_number: '',
      document_expire: '',
      document_type: DOCUMENT.PASSPORT,
    }
  }

  return {
    form: {
      ...currentPassport,
      document_type: ProfileTypes[type as IProfileTypes].documentType,
      hasMiddle: !!currentPassport?.middle_name,
    },
  }
}
